import { Tree } from "primereact/tree";
import { useEffect, useState } from "react";
import { AddKeyToNodes } from "../components/AddKeyToNodes";

import { Splitter, SplitterPanel } from 'primereact/splitter';
import { DirectoryIconGrayStyle, FileIcon, LocalServer, S3Icon, SharePointIcon } from "../icon_templates/icons";
import { FileExplorerView } from "../components/FileExplorerView";
import { AddFileIcon } from "../components/AddIconToNodes";


export const ExplorerV2 = () => {
    const [backend_lists, setBackendLists] = useState([]);
    const [backend_details, setBackendDetails] = useState([]);
    const [selected_backend_id, setSelectedBackendId] = useState();
    const [selected_node, setSelectedNode] = useState();
    const [thumbnail, setThumbnail] = useState();
    const [fileDetails, setFileDetails] = useState();
    const [selectedKey, setSelectedKey] = useState('');
    const [loading, setLoading] = useState(false);

const get_details_of_backends = (backendId, depth,path,key) => {
    setLoading(true);
    setSelectedBackendId(backendId);
    fetch(`/api/v1/explore/${backendId}/${depth}?path=${path}`, {
      method: "GET",
      headers: {
        "Content-Type": "application",
    }
    }).then(response => response.json())
    .then(data => {      
      if(path !== ""){
        const withChildren = insertIntoChildren(backend_details, data.sort((a,b)=> b.is_dir - a.is_dir), key);
        const addNodes = AddKeyToNodes(withChildren);
        console.log(addNodes)
        setBackendDetails(
          addNodes  
        )
        //console.log(insertIntoChildren(backend_details, data, key));
          
        }
        else{
        setBackendDetails(
          AddKeyToNodes(
            data.sort((a,b)=> b.is_dir - a.is_dir)
          )
        );
      }
      setLoading(false);      
    })
    .catch(error => console.log(error));
}

const isEmptyObject = (obj)=>{
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}

function insertIntoChildren(jsonArray, newJson, key) {
  for (let item of jsonArray) {
    if (item.key === key) {
        item.children = [];
        item.children.push(...newJson);
        return removeEmptyChildren(jsonArray); //jsonArray.filter((node) => !isEmptyObject(node));
    } else if (item.children && item.children.length > 0){
        let result = insertIntoChildren(item.children, newJson, key);
        if (result) {
            return removeEmptyChildren(jsonArray);
        }
    }
}
return null;
}

const removeEmptyChildren = (nodes) => {
  return nodes.map(node => {
      if (node.children && Array.isArray(node.children)) {
          node.children = node.children.filter(child => !isEmptyObject(child));
          node.children = removeEmptyChildren(node.children); // Recursively clean children
      }
      return node;
  });
};

const get_file_details = (backendId, path) => {
    Promise.all([
      fetch(`/api/v1/fetch/thumb/${backendId}/${path}`, {
        method: "GET",      
      }).then(response => response.blob())
      .then(data => {
        let objectURL = URL.createObjectURL(data);
        setThumbnail(objectURL);
        console.log(data);
      })
      .catch(error => console.log(error)),

      fetch(`/api/v1/fetch/details/${backendId}/${path}`, {
        method: "GET",      
      }).then(response => response.json())
      .then(data => {
        console.log(data);
        setFileDetails(data);
      })
      .catch(error => console.log(error))
    ])
}


// const addTitle = () => {
//   var list, index;
//   list = document.getElementsByClassName("p-treenode-label");
//   for (index = 0; index < list.length; ++index) {
//     console.log(list[index].textContent);
//       list[index].setAttribute('title', list[index].textContent);
//   }
// }

useEffect(() => {
    fetch("/api/v1/backends/", {
      method: "GET",
      headers: {
        "Content-Type": "application",
    }
    }).then(response => response.json())
    .then(data => {
      console.log(data);
      setBackendLists(data);
    })
    .catch(error => console.log(error));

    //addTitle();
}, []);

  return (
    <div className="container-fluid g-0">
      <div className="row g-0">
        <div className="col-3 col-md-3">
          <div style={{height : "calc(100vh - 60px)", backgroundColor : "#f8f9fa"}}>
            <div className="card h-100 rounded-0  border-top-0 border-bottom-0 border-start-0 bg-transparent">
                <div className="card-header d-grid gap-2">
                  <button className="btn btn-block btn-sm btn-dark">Add Storage</button>
                </div>
                <div className="card-body p-0">
                    <ul className="list-group ">
                        {backend_lists.map((backend, index) => (
                          <li 
                            key={index} 
                            className={selected_backend_id === backend.id ? 'list-group-item d-flex justify-content-between align-items-center py-3 cursor-pointer explorer-list-group active' : "list-group-item d-flex justify-content-between align-items-center py-3 cursor-pointer explorer-list-group"}                            
                            onClick={() => get_details_of_backends(backend.id, 1,"",0)}
                          >   
                            <div>
                              {
                                ['local','Local'].includes(backend.type) ? <img src={LocalServer} className="svg-icon-backend-type" alt="Local Server"/> : ['s3','S3'].includes(backend.type) ? <S3Icon/> : backend.type === 'Sharepoint' ? <SharePointIcon/> : ''
                              }
                              <span>{backend.backend_name}  </span>
                            </div>
                              
                              <span className="badge text-bg-dark rounded-pill">{backend.type}</span>
                          </li>
                        ))}
                    </ul>
                </div>
            </div>
          </div>
        </div>
        <div className="col-9 col-md-9">
          <Splitter>
            <SplitterPanel size={100} minSize={40} style={{backgroundColor : "#f8f9fa"}} className="flex align-items-center justify-content-center">
              <div style={{height : "calc(100vh - 60px)", backgroundColor : "#f8f9fa"}}>
                <div className="container-fluid">
                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-6 row-cols-md-10 g-2">
                        {
                            backend_details.length > 0 ?
                            backend_details.map((node, index) => (
                                <div className="col">
                                    <div className="card bg-transparent mt-1 exp-direc" tabIndex={index} >
                                        <div className="card-body p-1">
                                            <div className="text-center" title={node.label.replace("/","")}>
                                                {
                                                    node.is_dir ? <DirectoryIconGrayStyle/> : AddFileIcon(node.label) //<FileIcon IconStyleclassName="svg-file-explorer-icon"/>
                                                }
                                            </div>
                                        </div>
                                        <div className="card-footer bg-transparent border-0 text-center">
                                            <div style={{"fontSize" : '0.825rem', width:"100%", whiteSpace : "nowrap", textOverflow : "ellipsis", overflow: 'hidden'}} title={node.label.replace("/","")}>{node.label.replace("/","")}</div>
                                        </div>
                                    </div>
                                </div>
                            )) : 'No data available'
                        }
                    </div>
                </div>
              </div>                          
            </SplitterPanel>
          </Splitter>                  
        </div>       
      </div>
    </div>
  );
};
